import {LevelData} from "../interfaces/LevelData";
import {LevelDataState} from "../interfaces/LevelDataState";
import {LevelDataStage} from "../interfaces/LevelDataStage";
import {log} from "@dp-instant/utils";

const getStateFillColor = (state: Element) => {
    const paths = state.getElementsByTagName("path");
    for (let i = 0; i < paths.length; i++) {
        const fill = paths[i].getAttribute("fill");
        if (fill) {
            return fill;
        }
    }
    return null;
};
const getStatePaths = (state: Element) => {
    const paths = state.getElementsByTagName("path");
    const shapes: string[] = [];
    for (let i = 0; i < paths.length; i++) {
        const path = paths[i].getAttribute("d");
        if (path) {
            shapes.push(path);
        }
    }
    return shapes;
};
const getStateCentre = (state: Element) => {
    const check = (el: Element) => {
        if (el) {
            if (el.id.startsWith("Centre")) {
                return true;
            }
            if (el.id.startsWith("Ð¡entre")) {
                if (!state.id.startsWith("Ð¡entre")) {
                    console.warn(state.id, "starts with Ð¡entre");
                }
                return true;
            }
        }
        return false;
    };
    const groups = state.getElementsByTagName("g");
    for (let i = 0; i < groups.length; i++) {
        if (check(groups[i])) {
            const el: any = getStateCentre(groups[i]);
            if (el) {
                return el;
            }
        }
    }
    const circles = state.getElementsByTagName("circle");
    for (let i = 0; i < circles.length; i++) {
        if (check(circles[i].parentNode as Element)) {
            return circles[i];
        }
    }
    const ellipses = state.getElementsByTagName("ellipse");
    for (let i = 0; i < ellipses.length; i++) {
        if (check(ellipses[i].parentNode as Element)) {
            return ellipses[i];
        }
    }
};
const getStateCentrePos = (stateCentre: Element) => {
    const sx = stateCentre.getAttribute("cx")!;
    const sy = stateCentre.getAttribute("cy")!;
    return {x: parseInt(sx!, 10), y: parseInt(sy!, 10)};
};
const getStateCentreRadius = (stateCentre: Element) => {
    return parseInt(stateCentre.getAttribute("r")!, 10);
};
export const parseLevelSVG = (parsedData: Document): LevelData => {
    const svgRoot: SVGSVGElement = parsedData.children[0] as SVGSVGElement;
    const levelDataSVG = svgRoot!.children[0];
    log.debug("parse", levelDataSVG.id);
    const levelJson: LevelData = {id: levelDataSVG.id, states: [], stages: []};

    const transformState = (state: Element): LevelDataState => {
        const stateCentre = getStateCentre(state);
        const pos = getStateCentrePos(stateCentre);
        const radius = getStateCentreRadius(stateCentre);
        const fillColor = getStateFillColor(state);
        const shapes: string[] = getStatePaths(state);

        return {
            ...pos,
            radius,
            id: state.id,
            fillColor,
            shapes
        };
    };
    for (let i = 0; i < levelDataSVG.childElementCount; i++) {
        const child = levelDataSVG.children[i];
        if (child.id.toLocaleLowerCase().startsWith("stage")) {
            const stageData: LevelDataStage = {id: child.id, states: []};
            levelJson.stages.push(stageData);
            for (let j = 0; j < child.childElementCount; j++) {
                stageData.states.push(transformState(child.children[j]));
            }
            continue;
        }
        if (child.children.length !== 2) {
            // console.warn("wrong state children for", child.id);
            continue;
        }

        levelJson.states.push(transformState(child));
    }
    if (!levelJson.stages.length) {
        // try to use single stage if level file has no stages
        levelJson.stages = [{id: levelJson.id, states: levelJson.states}];
    }
    levelJson.stages = levelJson.stages.sort((a, b) => (a.id < b.id ? -1 : 1));

    return levelJson;
};
